import script from "./Social.vue?vue&type=script&lang=ts&setup=true"
export * from "./Social.vue?vue&type=script&lang=ts&setup=true"

import "./Social.vue?vue&type=style&index=0&id=263fb89d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-263fb89d"]])

export default __exports__